import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-data-source-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './data-source-switcher.component.html',
  styleUrls: ['./data-source-switcher.component.scss']
})
export class DataSourceSwitcherComponent {
  @Input() activeTab: 'satellites' | 'requests' = 'satellites';
  @Output() tabChange = new EventEmitter<'satellites' | 'requests'>();
  setActiveTab(tab: 'satellites' | 'requests'): void {
    this.activeTab = tab;
    this.tabChange.emit(tab);
  }
}